export default __webpack_public_path__ + "static/media/customer_bottom_banner.07d88e7f.jpg";